import ApiClientInterface from "@lib/ApiClient/ApiClientInterface";
import { InjectionToken } from "tsyringe";

export const lambdaApiClientToken = Symbol(
    "lambdaApiClientToken"
) as InjectionToken<ApiClientInterface>;
